import * as React from 'react';
import { useTranslation } from 'next-i18next';
import styles from '@utmb/features/city-maps/city-maps.module.scss';
import Image from 'next/image';
import { Font } from '@utmb/design-system/text/font';
import { CityMapsFilters } from '@utmb/types/city-maps';
import { useCityMaps } from '../../contexts/CityMapsContext';

const CityMapsLegend = (): React.ReactElement => {
    const { t } = useTranslation();

    const { legend, setLegend, color, availableLegend } = useCityMaps();

    const updateLegend = (filter: keyof CityMapsFilters): void => {
        const categoryNewState = { [filter]: !legend[filter] };

        setLegend({
            ...legend,
            ...categoryNewState,
        });
    };

    const PolylineIcon = () => (
        <svg viewBox="0 0 53.9 42.8" width="25" height="25">
            <path
                d="M53 21.8s-8.5-7.1-13.5 0c-2.3 3.2-3.1 12.7-12.1 12.3s-7-20.4-15.7-20.9C1.1 12.7 2 31.4 2 31.4"
                fill="none"
                stroke={color}
                strokeWidth="5"
            />
        </svg>
    );

    return (
        <div className={styles.legend}>
            {availableLegend.map((type) => {
                const isActive = legend[type];

                const legendItemClasses = [styles.legend_item, isActive && styles.legend_item_active].filter(Boolean).join(' ');
                const callback = (): void => updateLegend(type);
                return (
                    <a
                        className={legendItemClasses}
                        key={type}
                        style={isActive ? getStyle(color!) : {}}
                        onClick={callback}
                        onKeyPress={callback}
                        role="button"
                        tabIndex={0}
                    >
                        <span className={styles.legend_image}>
                            {type === 'polyline' ? <PolylineIcon /> : <Image width="25" height="25" src={`/map-markers/icon-${type}.svg`} />}
                        </span>
                        <Font.OxaniumBold mobile="12">{t(`cityMaps.category.${type}`)}</Font.OxaniumBold>
                    </a>
                );
            })}
        </div>
    );
};

export default CityMapsLegend;

const getStyle = (color: string): Record<string, unknown> => {
    return {
        borderLeft: `5px solid ${color}`,
    };
};
